import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class DeviceInstallation extends AbstractModel {
  @autoserialize
  personId: number;

  @autoserialize
  authenticated: boolean;

  @autoserialize
  timeZone: string;

  @autoserialize
  localeIdentifier: string;

  @autoserialize
  appVersion: string;

  @autoserialize
  appName: string;

  @autoserialize
  appIdentifier: string;

  @autoserialize
  badge: string;

  @autoserialize
  deviceType: string;

  @autoserialize
  deviceToken: string;

  @autoserialize
  pushServiceIdentifier: string;

  @autoserialize
  pushType: string;

  @autoserialize
  active: boolean;

  @autoserialize
  model: string;

  @autoserialize
  manufacturer: string;

  @autoserialize
  osType: string;

  @autoserialize
  osVersion: string;

  @autoserialize
  pushEnabled: boolean;

  @autoserialize
  uuid: string;

  @autoserialize
  locationPermission: string;

  @autoserialize
  motionTrackingEnabled: boolean;
}
